import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-left', 'ArrowLeft', [["path",{"d":"M19.5 12h-15m0 0 5.625-6M4.5 12l5.625 6","key":"svg-0"}]]);